import { render, staticRenderFns } from "./publishDetailRadio.vue?vue&type=template&id=4246357f&scoped=true&"
import script from "./publishDetailRadio.vue?vue&type=script&lang=js&"
export * from "./publishDetailRadio.vue?vue&type=script&lang=js&"
import style0 from "@assets/css/mediaDetails/mediaDetails.less?vue&type=style&index=0&id=4246357f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4246357f",
  null
  
)

component.options.__file = "publishDetailRadio.vue"
export default component.exports